import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { deleteUserAPIAction } from "../store/actions/UserActions";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";

const Home = () => {
  const [checked, setChecked] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userState = useSelector((state) => state.UserReducer);
  const deleteAccountApi = () => {
    dispatch(deleteUserAPIAction(toast, navigate));
  };

  return (
    <>
      <div className="mt-5 pt-3 container">
        <div className="content-card">
          <h2 className="page-title">
            Hi,{" "}
            {userState?.user &&
              userState?.user?.first_name.charAt(0).toUpperCase() +
                userState?.user?.first_name.slice(1)}{" "}
            {userState?.user &&
              userState?.user?.last_name.charAt(0).toUpperCase() +
                userState?.user?.last_name.slice(1)}{" "}
          </h2>
          <p className="lead mb-3">Thank you for logging into your account.</p>
          <p className="body-lg mb-2">
            This web page allows you to delete all your account information.
          </p>
          <p className="body-lg">
            If you're sure you want to delete your account, including your vehicles, reminders, and
            expenses, please proceed below.
          </p>

          <div className="danger-zone">
            <div className="danger-zone__title">Danger Zone</div>
            <p className="body-lg mb-2">Deleting your account will remove:</p>
            <ul className="danger-zone__list">
              <li>All vehicles and vehicle data</li>
              <li>All reminders and notifications</li>
              <li>All expenses and usage history</li>
            </ul>

            <div className="warning-card mt-3" role="alert">
              <div className="warning-row">
                <span className="warning-icon">!</span>
                <div>
                  <strong>This cannot be undone.</strong> Once deleted, your data will be
                  permanently removed from our system and cannot be restored.
                </div>
              </div>
            </div>

            <div className="form-check mt-3 d-flex align-items-start">
              <input
                className="form-check-input checkbox-lg"
                onClick={(e) => {
                  setChecked(e.target.checked);
                }}
                type="checkbox"
                value=""
                id="flexCheckChecked"
              />
              <label className="form-check-label checkbox-label" htmlFor="flexCheckChecked">
                I acknowledge and still want to delete my account in "Pakistan Petrol Price Today"
              </label>
            </div>
            <div className="d-flex flex-wrap gap-3 mt-4">
              <button
                className="btn btn-lg btn-danger"
                disabled={!checked}
                data-bs-toggle="modal"
                data-bs-target="#exampleModal"
              >
                Delete my account permanently
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="exampleModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg  modal-dialog-centered">
          <div className="modal-content ">
            <div className="modal-body">
              <div className="d-flex align-items-center justify-content-between">
                <h5>Are you sure you want to delete your account?</h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>

              <div className="alert alert-warning mt-3" role="alert">
                <div className="warning-row">
                  <span className="warning-icon">!</span>
                  <div>
                    I hereby confirm that I want to delete my account and all the relevant data.
                    <div className="mt-1">
                      <strong>This action cannot be undone.</strong>
                    </div>
                  </div>
                </div>
              </div>
              {/* <p>
                I hereby confirm that that I want to delete my account and all
                the relevant data.  
              </p> */}
              <div className="text-end d-md-flex align-items-center justify-content-between">
                <button
                  className="btn btn-outline-secondary mb-2 mb-md-0"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  id="modelForDeleteUserButton"
                >
                  Keep my account
                </button>
                <button className="btn btn-danger" onClick={deleteAccountApi}>
                  Delete my account permanently{" "}
                  {userState?.deleteUserLoading && (
                    <div
                      className="spinner-border"
                      role="status"
                      style={{ width: "20px", height: "20px" }}
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
